<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Regroupement</h2>
    </div>
  </div>
  <CriteresRechercheRegroupement @rechercher="rechercher" :secteurLibelles="secteurLibelles" :isRechercheDataLoading="isRechercheDataLoading"/>
  <ResultatRechercheRegroupement :regroupements="regroupements" :isRechercheDataLoading="isRechercheDataLoading" @removeRegroupementFromList="removeRegroupementFromList"/>
</template>

<script>
import CriteresRechercheRegroupement
  from '../../../../components/pilotage/Fichiers/Regroupement/CriteresRechercheRegroupement.vue'
import ResultatRechercheRegroupement
  from '../../../../components/pilotage/Fichiers/Regroupement/ResultatRechercheRegroupement.vue'

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    CriteresRechercheRegroupement,
    ResultatRechercheRegroupement
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Regroupement");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
            
    this.$store.dispatch("narration/rechercherDefaut48HeuresAction")
      .then((res) => {
        this.$store.commit("pilotage/SECTEUR_LIBELLES", res.data.entiteDecision.secteur.libelles);
        this.secteurLibelles = res.data.entiteDecision.secteur.libelles;
        let libelle = {};
        libelle.valeur = null;
        this.rechercher(libelle);
      });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      regroupements: [],
      isRechercheDataLoading: true,
      secteurLibelles: []
    }
  },
  methods: {
    rechercher(secteur) {
      this.regroupements = [];
      this.isRechercheDataLoading = true;
      this.$store.dispatch("pilotage/rechercherRegroupementAction", secteur).then((res) => {
        this.regroupements = res.data;
        this.isRechercheDataLoading = false;
      });
    },
    removeRegroupementFromList(cle) {
      this.regroupements = this.regroupements.filter(current => (current.cle != cle))
    }
  }
}
</script>
